import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const Departments = () => {
  const navigate = useNavigate();

  const env = import.meta.env["VITE_TARGET_ENV"] as string;

  useEffect(() => {
    if (env === "production") {
      navigate("/home");
    }
  }, [env, navigate]);

  return <div>Departments</div>;
};
